"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.clonedeepwith"));

var Utils = _interopRequireWildcard(require("../utils"));

var _Loc = _interopRequireDefault(require("./Loc"));

var _ColorScale = _interopRequireDefault(require("../ColorScale"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Node =
/*#__PURE__*/
function () {
  function Node($type, $loc) {
    _classCallCheck(this, Node);

    this.$type = $type;

    if ($loc) {
      this.$loc = $loc instanceof _Loc["default"] ? $loc : new _Loc["default"]($loc);
    }
  }

  _createClass(Node, [{
    key: "getDto",
    value: function getDto() {
      var _this = this;

      var withLoc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var dto = (0, _lodash["default"])(this, function (obj) {
        if (obj !== _this) {
          if (obj instanceof Node) {
            return obj.getDto(withLoc);
          } else if (obj instanceof _Loc["default"]) {
            return _this.$loc.toString();
          } else if (Utils.isColor(obj)) {
            return Utils.formatColor(obj);
          } else if (obj instanceof _ColorScale["default"]) {
            return String(obj);
          }
        }
      });

      if (!withLoc) {
        delete dto.$loc;
      }

      return dto;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      //if (this.$eval === void 0) {
      var value = this._evaluateInternal(e);

      if (value == null) {
        Utils.throwError("evaluation of '".concat(this.$type, "' is not supported by '").concat(e.$type, "'"), this.$loc);
      }

      this.$eval = value; //}

      return this.$eval;
    }
  }, {
    key: "_evaluateInternal",
    value: function _evaluateInternal()
    /*evaluator*/
    {
      throw new Error('Not implemented');
    }
  }]);

  return Node;
}();

exports["default"] = Node;